import {
  RepeatedInfoRequest,
  SimpleCbiEntitiesInfo,
} from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const getSimpleCbiEntitiesInfo = (
  req: IndexSignature<RepeatedInfoRequest>
): Promise<SimpleCbiEntitiesInfo> =>
  request({
    url: '/service/cbientityservice/GetSimpleCbiEntitiesInfo',
    body: req,
  }).then((r) => r.body);
